/**
 * Aspect ratio (width ÷ height) of a Prismic image field.
 *
 * `gatsbyImageData` is an opaque scalar with no selectable subfields, so the ratio has to come
 * from Prismic's own `dimensions { width height }` — query that alongside `gatsbyImageData`
 * wherever the ratio drives layout.
 *
 * Falls back to 1 when the field is empty or unqueried, so sizing math can never produce
 * `NaN` and collapse an element. Prismic image fields are frequently empty (see
 * docs/conventions.md), and an empty field returns `null` for every subfield.
 */
export const aspectRatio = image =>
  image && image.dimensions && image.dimensions.height
    ? image.dimensions.width / image.dimensions.height
    : 1

export default aspectRatio
